// Supabase Connection Diagnostics
// Add this to help debug "Load failed" network errors

import { supabase } from '../admin/lib/supabaseClient';

export async function diagnoseSupabaseConnection() {
  console.group('🔍 Supabase Connection Diagnostics');
  
  // 1. Check environment variables
  console.log('Environment Variables:');
  console.log('  SUPABASE_URL:', process.env.REACT_APP_SUPABASE_URL ? '✅ Set' : '❌ Missing');
  console.log('  SUPABASE_ANON_KEY:', process.env.REACT_APP_SUPABASE_ANON_KEY ? '✅ Set (length: ' + process.env.REACT_APP_SUPABASE_ANON_KEY?.length + ')' : '❌ Missing');
  
  // 2. Check supabase client
  console.log('\nSupabase Client:');
  console.log('  Client initialized:', supabase ? '✅ Yes' : '❌ No');
  
  // 3. Check network connectivity
  console.log('\nNetwork Status:');
  console.log('  navigator.onLine:', navigator.onLine ? '✅ Online' : '❌ Offline');
  
  // 4. Test DNS resolution
  if (process.env.REACT_APP_SUPABASE_URL) {
    try {
      const url = new URL(process.env.REACT_APP_SUPABASE_URL);
      console.log('  Supabase host:', url.hostname);
      
      // Try a simple fetch to test connectivity
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);
      
      console.log('  Testing connection...');
      const testStart = Date.now();
      
      const response = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/rest/v1/`, {
        method: 'HEAD',
        signal: controller.signal,
        headers: {
          'apikey': process.env.REACT_APP_SUPABASE_ANON_KEY || '',
        }
      });
      
      clearTimeout(timeoutId);
      const testDuration = Date.now() - testStart;
      
      console.log('  Connection test:', response.ok ? '✅ Success' : '⚠️ Failed');
      console.log('  Response status:', response.status);
      console.log('  Response time:', testDuration + 'ms');
      console.log('  CORS headers:', response.headers.get('access-control-allow-origin') || 'Not present');
      
    } catch (error: any) {
      console.log('  Connection test: ❌ Failed');
      console.log('  Error type:', error.name);
      console.log('  Error message:', error.message);
      
      if (error.name === 'AbortError') {
        console.log('  ⚠️ Connection timed out after 5 seconds');
      } else if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        console.log('  ⚠️ Network error - possible causes:');
        console.log('     - DNS resolution failed');
        console.log('     - Firewall/network blocking');
        console.log('     - VPN/proxy issues');
        console.log('     - Browser security policy');
      }
    }
  }
  
  // 5. Test actual Supabase query
  console.log('\nTest Query:');
  try {
    const { data, error } = await supabase
      .from('customer_interactions')
      .select('count', { count: 'exact', head: true });
    
    if (error) {
      console.log('  Query test: ❌ Failed');
      console.log('  Error:', error.message);
      console.log('  Code:', error.code);
    } else {
      console.log('  Query test: ✅ Success');
      console.log('  Table accessible: Yes');
    }
  } catch (error: any) {
    console.log('  Query test: ❌ Exception');
    console.log('  Error:', error.message);
  }
  
  console.groupEnd();
}

// Auto-run diagnostics if DEBUG flag is set
if (localStorage.getItem('SUPABASE_DEBUG') === '1') {
  setTimeout(() => {
    diagnoseSupabaseConnection().catch(console.error);
  }, 1000);
}

export {};
